define("powergen/components/x-keyboard-key",
  [],
  function() {
    "use strict";
    var XKeyboardKeyComponent;

    XKeyboardKeyComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['keyboard-key'],
      classNameBindings: ['keyClass', 'key.alt:key-alt'],
      keyClass: (function() {
        return 'key-%@'.fmt(this.get('key.id'));
      }).property(),
      click: function() {
        return this.sendAction('keyUpAction', this.get('key'));
      }
    });


    return XKeyboardKeyComponent;
  });